

















import ApiClient from '@/js/api.js'
import PopupTemplate from '@/views/templates/tenugui/PopupTemplate.vue'
import QuizTenugui from '@/views/organisms/QuizTenugui.vue'

export default
  components: {
    PopupTemplate
    QuizTenugui
  }

  data: () ->
    baseColor: '#4D2095'
    point: 0
    mode: 0
    quizResult: 0
    quizData:
      hukidashi: [
        '強力な速乾性能をもつスポーツてぬぐい。'
        '水に濡らして絞った状態から約1時間放置すると最大何％水分量が減少するでしょうか？'
      ]
      quiz: [
        '38%'
        '74%'
        '62%'
      ]
      success_message: [
        '一般的なパイル地のタオルを水に濡らして絞った状態から'
        '約1時間放置すると、水分量が21%減少するのに対して、'
        'スポーツてぬぐいは最大74%も減少するんだ。'
      ]
      answer: 2

  methods: {
    closePopup: () ->
      m = @mode
      if m == 0
        m = 2
      @$emit('closePopup', m)
    success: () ->
      @mode = 3
      @quizResult = 2
      @baseColor = '#F699AB'
      api = new ApiClient()
      param =
        'point_code': 'p2-15'
      data = await api.post('/member/point/save', true, param)
      @point = data.point
      if @point > 0
        @$emit('addPoint', @point)
    miss: () ->
      @baseColor = '#7BCAD8'
      @mode = 2
      @quizResult = 1
  }
